import { dynamicFailed } from "../hooks/useToast";
import { ICooperative } from "../exports/interfaces";
import axiosClient from "../axioxClient.ts/axiosClient";

export const fetchCooperative = async (): Promise<ICooperative[]> => {
  try {
    const response = await axiosClient.get<ICooperative[]>("/registers");
    return (response.data || []).sort((a, b) => {
      const dateA = a.createdAt ? new Date(a.createdAt).getTime() : 0;
      const dateB = b.createdAt ? new Date(b.createdAt).getTime() : 0;
      return dateB - dateA;
    });
  } catch (error: any) {
    const message = error?.response?.data?.message || "Something went wrong!";
    dynamicFailed(message);
    return [];
  }
};
